export default __webpack_public_path__ + "static/media/IMG_9058-medium.24daf52f.jpg";